<script>
    // -- IMPORTS

    import { fetchData, getProcessedMultilineTranslatedText } from '$lib/base.js';
    import { enabledAdminView } from '$lib/store/adminStore.js';
    import { languageTagStore } from '$lib/store/languageTagStore';
    import { textStore } from '$lib/store/textStore';
    import AdminEditButton from '$lib/component/element/AdminEditButton.svelte';
    import AnimatedText from '$lib/component/element/AnimatedText.svelte';
    import { pageStore } from '../store/pageDataStore';
    import { onMount } from 'svelte';
    import FullLoading from '../component/Layout/FullLoading.svelte';
    import RenderBlockByType from '../component/element/renderBlockByType.svelte';
  import PageHeading from '../component/header/PageHeading.svelte';

    // -- VARIABLES

    let isLoading = $state(true);

    let whatsBamhubPage = $state($pageStore.page.whatsBamhub);
    let whatsBamhubBlockArray = $state($pageStore.block.whatsBamhubBlockArray);

    async function loadData(
        )
    {
        try
        {
            isLoading = true

            let pageData =
                await fetchData(
                    '/api/page/what-is-bamhub',
                    {
                        method: 'POST',
                        body: JSON.stringify(
                            {
                            },
                        ),
                        headers: { 'Content-Type': 'application/json' }
                    }
                    );

            $pageStore.page.whatsBamhub = pageData.page;
            $pageStore.block.whatsBamhubBlockArray = pageData.blockArray;

            whatsBamhubPage = pageData.page;
            whatsBamhubBlockArray = pageData.blockArray;
        }
        catch ( error )
        {
            console.error( 'Error:', error )
        }
        finally
        {
            isLoading = false;
        }
    }

    // -- STATEMENTS

    onMount(
        () =>
        {
            if
            (
                whatsBamhubPage === undefined
                || whatsBamhubBlockArray === undefined
            )
            {
                loadData();
            }
            else
            {
                isLoading = false;
            }
        }
        );
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../constant.styl';
    @import '../../mixin.styl';

    // -- CLASSES

    :global( html > body > div > main )
    {
        background: unset;
        background-color: darkGreyColor;
    }

    .what-is-bamhub-section
    {
        border: 1px solid borderColor;
        padding: 0 1.5rem 5rem;

        display: flex;
        flex-direction: column;
        gap: 4rem;

        +media( desktop )
        {
            margin: 0;
            margin-bottom: 5rem;
            max-width: 77vw;
            border: none;
            padding-bottom: 0;
        }
    }

    .networking-section
    {
        padding: 5rem 1.5rem;

        gap: 5rem;

        +media( desktop )
        {
            max-width: 77vw;
        }
    }

    .networking-heading
    {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        align-items: center;
        align-self: stretch;
    }

    .networking-title
    {
        line-height: 2.5rem;
        font-size: 2rem;
        letter-spacing: 0.16rem;
        text-transform: uppercase;

        +media( desktop )
        {
            line-height: 7.5rem;
            font-size: 6rem;
            font-weight: 250;
            letter-spacing: 0.48rem;
            text-align: center;
        }
    }

    .what-we-offer-container
    {
    }

    @keyframes infinite-scroll
    {
        to
        {
            transform: translate( calc( -50% - 0.5rem ) );
        }
    }

    .what-we-offer-container
    {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        align-items: center;
        align-self: stretch;

        +media( desktop )
        {
            gap: 5rem;
        }
    }

    .what-we-offer-card-list
    {
        display: flex;
        flex-direction: column;
        gap: 4rem;
        align-items: center;
        align-self: stretch;

        +media( desktop )
        {
            gap: 4rem;
        }
    }
</style>

<section class="what-is-bamhub-section">
    {#if isLoading}
        <FullLoading />
    {:else}
        <div class="what-we-offer-container">
            <PageHeading
                title={ whatsBamhubPage.title }
                subtitle={ whatsBamhubPage.subtitle }
            />

            <RenderBlockByType
                blockArray={ whatsBamhubBlockArray }
                pageId={ whatsBamhubPage.id }
            />
        </div>
    {/if}
</section>
